// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"414":"b9a1895c","658":"f5c15f2c"}[chunkId] + ".chunk.css";
};